<template>
  <div style="display: flex;justify-content: start;align-items: center;width: 100vw;height: 100%;flex-direction: column;overflow-y: auto;">
    <div style="display: flex;justify-content: start;align-items: center;width: 100vw;height: 100%;flex-direction: column;">
      <div style="display: flex;justify-content: start;align-items: center;flex-direction: row;background-size: 100% 100%;position: fixed;top:0;left: 0;"
      :style="{ 'background-image': 'url(' + bannerBg + ')','width':'100vw','height':'calc(100vw / 24)'}">
        <span style="width: 25vw;height: 1px;"></span>
        <div style="display: flex;justify-content: space-between;align-items: center;width: 60vw;height: 100%;flex-direction: row;">
          <div v-for="(item,index) in bannerUnSelectedImgs" :key="index" 
          style="display: flex;justify-content: center;align-items: center;width: calc(60vw/7.5);height: calc(60vw/7.5/2.781818);flex-direction: column;">
            <img :src="currentScrollTag == item.id?item.selectedsrc:item.unselectedsrc" style="width: 100%;height: 100%;" @click="clickBanner(item.id)"/>
          </div>
        </div>
      </div>
      <span style="width: 100vw;height: calc(100vw / 24);"></span>
      <div id="1-banner" style="display: flex;justify-content: start;align-items: start;flex-direction: column;background-size: 100% 100%;"
      :style="{ 'background-image': 'url(' + oneBg + ')','width':'100vw','height':'calc(100vw / 1.7777777)'}">
        <span style="width: 100vw;height: 90.4%;"></span>
        <span style="width: auto;height: 2.75%;margin-left: 21%;font-size: 1.5vw;font-weight: bold;color: white;">{{reservationNum}}</span>
        <!-- <div style="display: flex;justify-content: space-between;align-items: center;width: 60%;height: 15%;flex-direction: row;">
          <span style="width: 50%;"></span>
          <span style="width: 50%;height: 100%;" @click="clickBooking()"></span>
        </div> -->
    
      </div>
      <div id="2-banner" style="display: flex;justify-content: start;align-items: center;flex-direction: column;background-size: 100% 100%;"
      :style="{ 'background-image': 'url(' + getLevel(reservationNum) + ')','width':'100vw','height':'calc(100vw / 1.584)'}">
        <span style="width: 100vw;height: 10%;"></span>
        <span style="width: 30vw;height: 10%;" @click="预约"></span>
        <span style="width: 100vw;height: 60%;"></span>
        <div style="display: flex;justify-content: space-between;align-items: center;width: 55vw;height: calc(100vw / 1.584 * 0.1);flex-direction: row;">
          <span style="width: 1vw;height: 10%;"></span>
          <img src="~assets/pictures/two/2-login.png" style="height: calc(100vw / 1.584 * 0.1);width: calc(100vw / 1.584 * 0.1);" @click="clickBooking()">
        </div>

    
      </div>
      <div id="3-banner" style="display: flex;justify-content: center;align-items: center;flex-direction: column;background-size: 100% 100%;"
      :style="{ 'background-image': 'url(' + threeBg + ')','width':'100vw','height':'calc(100vw / 1.777777)'}">
      </div>
      <div id="4-banner" style="display: flex;justify-content: start;align-items: center;flex-direction: column;background-size: 100% 100%;"
      :style="{ 'background-image': 'url(' + fourBg + ')','width':'100vw','height':'calc(100vw / 1.77777)'}">

        <div style="display: flex;justify-content: space-between;align-items: center;width: 70vw;height: calc(100vw / 1.77777 * 0.49);flex-direction: row;margin-top: 19.5%;">
          <img src="~assets/pictures/left.png" style="width: 6vw;height: calc(6vw/1.0283);" @click="fourLeftClick()">
          <div style="display: flex;justify-content: start;align-items: center;width: calc(100vw / 1.77777 * 0.49 * 1.818181);height: calc(100vw / 1.77777 * 0.49);flex-direction: column;">
            <img :src="fourImgs[fourCurrentIndex]" style="width:100%;height:100%">
          </div>
          <img src="~assets/pictures/right.png" style="width: 6vw;height: calc(6vw/1.0283);" @click="fourRightClick()">
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;width: 50vw;height: calc(100vw / 1.77777 * 0.08);flex-direction: row;margin-top: 2%;">
          <img v-for="(item,index) in fourImgs" :key="index" 
          :src="fourCurrentIndex == index?fourDotHitImg:fourDotNormalImg" 
          style="width:calc(100vw / 1.77777 * 0.08 * 0.8 * 2.45);height:calc(100vw / 1.77777 * 0.08 * 0.8)">
        </div>
    
      </div>
      <div id="5-banner" style="display: flex;justify-content: start;align-items: center;flex-direction: column;background-size: 100% 100%;"
      :style="{ 'background-image': 'url(' + fiveBg + ')','width':'100vw','height':'calc(100vw / 1.77777)'}">
        <div style="display: flex;justify-content: space-between;align-items: center;width: 70vw;height: calc(100vw / 1.77777 * 0.5);flex-direction: row;margin-top: 19%;">
          <img src="~assets/pictures/left.png" style="width: 6vw;height: calc(6vw/1.0283);" @click="fiveLeftClick()">
          <div style="display: flex;justify-content: start;align-items: center;width: calc(100vw / 1.77777 * 0.5 * 1.77407);height: calc(100vw / 1.77777 * 0.5);flex-direction: column;">
            <img :src="fiveImgs[fiveCurrentIndex]" style="width:100%;height:100%">
          </div>
          <img src="~assets/pictures/right.png" style="width: 6vw;height: calc(6vw/1.0283);" @click="fiveRightClick()">
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;width: 50vw;height: calc(100vw / 1.77777 * 0.08);flex-direction: row;margin-top: 2%;">
          <img v-for="(item,index) in fiveImgs" :key="index" 
          :src="fiveCurrentIndex == index?fiveDotHitImg:fiveDotNormalImg" 
          style="width:calc(100vw / 1.77777 * 0.08 * 0.8 * 1.054545);height:calc(100vw / 1.77777 * 0.08 * 0.8)">
        </div>
    
      </div>
      <span id="6-banner"></span>
      <div id="7-banner" style="display: flex;justify-content: start;align-items: center;flex-direction: column;background-size: 100% 100%;"
      :style="{ 'background-image': 'url(' + sixBg + ')','width':'100vw','height':'calc(100vw / 2.361623)'}">
        <img src="~assets/pictures/six/download.png" style="width: 20vw;height: calc(20vw/3.2);margin-top: 10%;" @click="dowanload()">
        <!-- <img v-if="yuYue" src="~assets/pictures/six/download.png" style="width: 20vw;height: calc(20vw/3.2);margin-top: 10%;" @click="dowanload()">
        <img v-else src="~assets/pictures/six/reservation.png" style="width: 20vw;height: calc(20vw/3.2);margin-top: 10%;" @click="clickYuYue()"> -->
      </div>
    </div>
    <PhoneReservation v-if="showReservationPage" style="position: fixed;top:0;z-index: 100;" @goReservation="goReservation"></PhoneReservation>
    <div style="display: flex;justify-content: start;align-items: center;flex-direction: column;background-size: 100% 100%;position: fixed;right: 0;top: 10vw;"
      :style="{ 'background-image': 'url(' + sideBarImg + ')','width':'5vw','height':'calc(5vw / 0.140816)'}">
        <div style="display: flex;justify-content: space-between;align-items: center;width: 5vw;height: calc(5vw / 0.140816 * 0.86);flex-direction: column;margin-top: calc(5vw / 0.140816 * 0.1);">
          <span v-for="(item, index) in [0,1,2,3,4,5,6]" :key="index" style="width: 5vw;height: calc(5vw / 0.140816 * 0.86 / 8.4);" @click="sideBarClcik(index)"></span>
        </div>
    </div>

    <div v-if="showCustomeServicePage" style="display: flex;justify-content: center;align-items: center;flex-direction: column;position: fixed;right: 0;z-index: 2000;background-color: #000000BB;width: 100%;height: 100%;">
        <div style="display: flex;justify-content: start;align-items: center;flex-direction: column;background-size: 100% 100%;"
        :style="{ 'background-image': 'url(' + customerServiceImg + ')','width':'50vw','height':'calc(50vw / 1.411439)'}">
        <div style="display: flex;justify-content: start;align-items: center;width: 100%;height: calc(50vw / 1.411439 * 0.756);flex-direction: column;">
          <div style="display: flex;justify-content: space-between;align-items: center;width: 100%;height: 18%;flex-direction: row;margin-top: 3%;">
            <span style="width: 10%;height: 10px;"></span>
            <span style="width: 12%;height: 100%;" @click="showCustomeServicePage = false"></span>
          </div>
        </div>
        <span style="width: 75%;height: calc(50vw / 1.411439 * 0.154);background-color: transparent;" @click="clickCustomerService()"></span>
        </div>
    </div>
    <div v-if="showWeChatCodePage" 
    style="display: flex;justify-content: center;align-items: center;flex-direction: column;position: fixed;right: 0;z-index: 2000;background-color: #000000D2;width: 100%;height: 100%;color: white;font-size: 1.5vw;font-weight: bold;" @click="showWeChatCodePage = false">
        <img src="~assets/pictures/weChatCode.png" style="height: 20vw;width: 20vw;">
    </div>

    <div v-if="showOutsideDownloadPage" style="display: flex;justify-content: start;align-items: center;width: 100%;height: 100%;flex-direction: column;position: fixed;top:0;z-index: 100;background-color: #454545;" @click="showOutsideDownloadPage = false">
      <img src="~assets/pictures/outside-download.jpg" style="width: 100vw;height: calc(100vw / 0.52117);">
    </div>

  </div>
</template>

<script>
  import qs from 'qs';
  import { request } from '../network/request';
  import getRequestParams from "../signParams";
  import PhoneReservation from '@/views/PhoneReservation'
  export default {
    props:{
      
    },
    data () {
      return {
        bannerBg: require('@/assets/pictures/banner/bg.png'),
        bannerUnSelectedImgs:[
          {'id':'1-banner','unselectedsrc':require('@/assets/pictures/banner/1_unselected.png'),'selectedsrc':require('@/assets/pictures/banner/1_selected.png')},
          {'id':'2-banner','unselectedsrc':require('@/assets/pictures/banner/2_unselected.png'),'selectedsrc':require('@/assets/pictures/banner/2_selected.png')},
          {'id':'3-banner','unselectedsrc':require('@/assets/pictures/banner/3_unselected.png'),'selectedsrc':require('@/assets/pictures/banner/3_selected.png')},
          {'id':'4-banner','unselectedsrc':require('@/assets/pictures/banner/4_unselected.png'),'selectedsrc':require('@/assets/pictures/banner/4_selected.png')},
          {'id':'5-banner','unselectedsrc':require('@/assets/pictures/banner/5_unselected.png'),'selectedsrc':require('@/assets/pictures/banner/5_selected.png')},
          {'id':'6-banner','unselectedsrc':require('@/assets/pictures/banner/6_unselected.png'),'selectedsrc':require('@/assets/pictures/banner/6_selected.png')},
          // {'id':'7-banner','unselectedsrc':require('@/assets/pictures/banner/7_unselected.png'),'selectedsrc':require('@/assets/pictures/banner/7_selected.png')}
        ],
        bannerUnSelectedImgsLength:6,
        bannerClickedIndex: 0,
        ticking: false, // 锁标记
        currentScrollTag:'1-banner',
        timer: null,

        fourCurrentIndex:0,
        fourImgs:[
          require('@/assets/pictures/four/1.png'),require('@/assets/pictures/four/2.png'),
          require('@/assets/pictures/four/3.png'),require('@/assets/pictures/four/4.png')
        ],
        fourDotHitImg:require('@/assets/pictures/four/dot-hit.png'),
        fourDotNormalImg:require('@/assets/pictures/four/dot-normal.png'),
        fourTimer:null,

        
        fiveCurrentIndex:0,
        fiveImgs:[
          require('@/assets/pictures/five/1.png'),require('@/assets/pictures/five/2.png'),
          require('@/assets/pictures/five/3.png'),require('@/assets/pictures/five/4.png'),
          require('@/assets/pictures/five/5.png'),require('@/assets/pictures/five/6.png'),
        ],
        fiveDotHitImg:require('@/assets/pictures/five/dot-hit.png'),
        fiveDotNormalImg:require('@/assets/pictures/five/dot-normal.png'),
        fiveTimer:null,

        oneBg: require('@/assets/pictures/one.png'),
        threeBg: require('@/assets/pictures/three.png'),
        fourBg: require('@/assets/pictures/four/bg.png'),
        fiveBg: require('@/assets/pictures/five/bg.png'),
        sixBg: require('@/assets/pictures/six/bg.png'),
        sideBarImg: require('@/assets/pictures/sideBar.png'),
        customerServiceImg: require('@/assets/pictures/customerService.png'),

        showCustomeServicePage: false,

        hadReservation: false,
        reservationNum: 0,

        
        gWidth:0,
        gheight:0,
        space:0,


        showReservationPage: false,//展示手机预约界面

        showServicePic:false,
        showGzhPic:false,

        selectedTeSeIndex: 0,
        yuYue: false,

        showWeChatCodePage: false,
        showOutsideDownloadPage: false,
      }
    },
    components: {
      PhoneReservation
    },
    created:function(){
      this.changeWidth();
      if (window.orientation == 90 || window.orientation == -90) {
        //ipad、iphone竖屏；Andriod横屏
        console.log("横屏");
      }
      else if (window.orientation == 0 || window.orientation == 180) {
        //ipad、iphone横屏；Andriod竖屏
        console.log("竖屏");
      }
    
      this.updateReservationNum()

      
    },
    mounted:function(){
      // window.onresize = () => {
      //   this.changeWidth();
      // };
      // 绑定的是优化过的 onScroll，而不是直接绑定 checkByTop
      window.addEventListener('scroll', this.onScroll);
      this.startFourTimer()
      this.startFiveTimer()
    },
    beforeUnmount() {
      window.removeEventListener('scroll', this.onScroll);
      this.stopTimer()
    },
    watch:{
      showReservationPage:{
        handler(newValue, oldValue) {
          if (newValue) {
            document.body.classList.add('lock-scroll');
          }else{
            document.body.classList.remove('lock-scroll');
          }
        }
      },
      showCustomeServicePage:{
        handler(newValue, oldValue) {
          if (newValue) {
            document.body.classList.add('lock-scroll');
          }else{
            document.body.classList.remove('lock-scroll');
          }
        }
      },
      // currentScrollTag:{
      //   handler(newValue, oldValue) {
      //     // console.log("newValue",newValue);
      //     this.stopTimer()
      //     if (newValue == '4-banner') {
      //       // 启动轮播
      //       this.startFourTimer()
      //     }else if(newValue == '5-banner'){
      //       this.startFiveTimer()
      //     }
      //   }
      // },
    },
    methods: {
      startFourTimer(){
        if (this.fourTimer) {
          return
        }
        this.fourTimer = setInterval(() => {
          this.fourRightClick();
        }, 2500); 
      },
      startFiveTimer(){
        if (this.fiveTimer) {
          return
        }
        this.fiveTimer = setInterval(() => {
          this.fiveRightClick();
        }, 2500); 
      },
      stopTimer(){
        if (this.fourTimer) {
          clearInterval(this.fourTimer)
          this.fourTimer = null
        }
        if (this.fiveTimer) {
          clearInterval(this.fiveTimer)
          this.fiveTimer = null
        }
        
      },
      onScroll() {
        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.checkByTop(); // 执行真正的逻辑
            this.ticking = false; // 解锁
          });
          this.ticking = true; // 上锁
        }
      },
      checkByTop() {
        for (let index = 0; index < this.bannerUnSelectedImgsLength; index++) {
          const idTag = this.bannerUnSelectedImgs[index].id;
          const element = document.getElementById(idTag)
          const scrollPosition = window.scrollY + 300 // 偏移量
          
          if (scrollPosition >= element.offsetTop) {
            // console.log('已滚动到 1-banner 区域')
            this.currentScrollTag = idTag
          }
        }
      },
      clickBanner(id){
        if (id == '6-banner') {
          // 显示客服中心
          this.showCustomeServicePage = true
          // return
        }
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.ticking = true
        // 平滑滚动
        const section = document.getElementById(id)
        if (section) {
          section.scrollIntoView({ 
            behavior: 'smooth',
            block: 'center' // 'start' | 'center' | 'end'
          })
          this.currentScrollTag = id
          this.timer = setTimeout(() => {
            this.ticking = false
            clearTimeout(this.timer)
          }, 1200);
        }
      },
      clickBooking(){
        this.showReservationPage = true
      },
      updateReservationNum(){
        // 出征吧勇士 pageid =5
        let paramters = {'pageid':'5'}
        paramters = qs.stringify(paramters)
        console.log('paramters',  paramters);
        request({
          url:this.urls.appointmentNum,
          data: paramters,
        }).then(res =>{
          console.log('appointmentNum == ', res);
          this.reservationNum = res['count']
        })
      },
      getLevel(num) {
        // 使用下划线 _ 增加可读性，JS引擎会自动识别为数字
        if (num >= 1000000) {
          // return '100万级别';
          return require('@/assets/pictures/two/2-100w.png');
        } else if (num >= 800000) {
          // return '80万级别';
          return require('@/assets/pictures/two/2-80w.png');
        } else if (num >= 500000) {
          // return '50万级别';
          return require('@/assets/pictures/two/2-50w.png');
        } else if (num >= 300000) {
          // return '30万级别';
          return require('@/assets/pictures/two/2-30w.png');
        } else if (num >= 100000) {
          // return '10万级别';
          return require('@/assets/pictures/two/2-10w.png');
        } else {
          // return '不足10万';
          return require('@/assets/pictures/two/2-0.png');
        }
      },
      fourLeftClick(){
        // 如果是第一张，回到最后一张
        this.fourCurrentIndex = (this.fourCurrentIndex - 1 + this.fourImgs.length) % this.fourImgs.length;
      },
      fourRightClick(){
        // 如果是最后一张，回到第一张 (取余算法)
        this.fourCurrentIndex = (this.fourCurrentIndex + 1) % this.fourImgs.length;
      },
      fiveLeftClick(){
        // 如果是第一张，回到最后一张
        this.fiveCurrentIndex = (this.fiveCurrentIndex - 1 + this.fiveImgs.length) % this.fiveImgs.length;
      },
      fiveRightClick(){
        // 如果是最后一张，回到第一张 (取余算法)
        this.fiveCurrentIndex = (this.fiveCurrentIndex + 1) % this.fiveImgs.length;
      },
      //根据电脑分辨率设置轮播图宽度
      changeWidth() {
        this.cWidth = document.body.clientWidth
        this.cheight = this.cWidth * 1.04
        this.space = this.cWidth * 1.5

        // if (this.isMobile) {
        //   this.gWidth = (this.cWidth / 1.1627) * 0.75
        // }else{
        //   this.gWidth = (this.cWidth / 1.1627) * 0.72
        // }
          this.gWidth = (this.cWidth / 1.1627) * 0.72
        this.gheight = this.gWidth / 1.7767
      },
      
      clickSpecialArrowLeft(){
        if (this.selectedTeSeIndex <= 0) {
          return
        }
        this.selectedTeSeIndex -= 1
      },
      clickSpecialArrowRight(){
        if (this.selectedTeSeIndex >= 4) {
          return
        }
        this.selectedTeSeIndex += 1
      },
      scrollToAnchor(elementId) {
        console.log("点击  scrollToAnchor");
        event.preventDefault()
        // const hash = event.target.hash
        // const target = document.querySelector(hash)
        document.getElementById(elementId).scrollIntoView({ behavior: 'smooth' })
        // target.scrollIntoView({ behavior: 'smooth' })
      },
      goReservation(flag){
        // 预约
        this.showReservationPage = false
        this.updateReservationNum()
        if (flag) {
          this.yuYue = true
        }
        // //关闭手机预约界面时，再刷新一下人数
        // if (!flag) {
        //   this.updateReservationNum()
        //   return
        // }
      },
      toAppleDownload(){
        // https://apps.apple.com/cn/app/id6473833904
        // window.location.href = 'https://apps.apple.com/cn/app/id6473833904'
      },
      toTapTapDownload(){
        // https://www.taptap.cn/app/416057
        // window.location.href = 'https://tap.cn/8DRoHUf3?channel=rep-rep_2gb0xriiwjp'
      },
      toHykbDownload(){
        // https://www.3839.com/a/160626.htm
        // window.location.href = 'https://www.3839.com/a/160626.htm'
      },
      clickIOS(){
        // window.open('https://d.gzsw168.com/html/PrivacyPolicy-gzsz.html', '_blank');
      },
      clickAndroid(){
        // window.open('https://d.gzsw168.com/html/PrivacyPolicy-gzsz.html', '_blank');
      },
      clickCustomerService(){
        window.open('https://work.weixin.qq.com/kfid/kfcd24f4f2f52774ed0', '_blank');
        this.howCustomeServicePage = false
      },
      clickYuYue(){
        // this.$store.commit('switchLoading', true)
        if (!this.yuYue) {
          this.showReservationPage = true
          document.body.classList.add('lock-scroll');
        }
        // this.switchToast({"showOrHide": true, "toastMessage": "预约成功！"});
        // this.yuYue = true
      },
      dowanload(){
        // if (!this.yuYue) {
        //   this.showReservationPage = true
        //   document.body.classList.add('lock-scroll');
        //   return
        // }
         // return
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        
        var isMobile = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i); // 是否手机端
        var isWx = /micromessenger/i.test(navigator.userAgent); // 是否微信
        var isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信
        // 判断iOS
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {

          if (isComWx && isMobile) { //手机端企业微信
            this.showOutsideDownloadPage = true
          }
          else if (isComWx && !isMobile) { //PC端企业微信
            this.showOutsideDownloadPage = true
          }
          else if (isWx && isMobile) { // 手机端微信
            this.showOutsideDownloadPage = true
          }
          else if (isWx && !isMobile) { // PC端微信
            this.showOutsideDownloadPage = true
          }
          else {
            // 实际处理
            window.open("https://d.gzsw168.com/lp/efTKO400.html", '_blank')
          }

        } 
        // else if (/android/i.test(userAgent)) {
        //   // 判断Android
        //   // this.os = 'Android';
        //   window.location.href = 'https://d.gzsw168.com/source/apk/9812_f4931.apk'
        // } 
        else {
          // 其他操作系统
          // this.os = '可能不是移动操作系统';
          if (isComWx && isMobile) { //手机端企业微信
            this.showOutsideDownloadPage = true
          }
          else if (isComWx && !isMobile) { //PC端企业微信
            this.showOutsideDownloadPage = true
          }
          else if (isWx && isMobile) { // 手机端微信
            this.showOutsideDownloadPage = true
          }
          else if (isWx && !isMobile) { // PC端微信
            this.showOutsideDownloadPage = true
          }
          else {
            // 实际处理
            window.open("https://d.gzsw168.com/lp/efTKO400.html", '_blank')
          }
        }
      },
      sideBarClcik(index){
        switch (index) {
          case 0://雷电
            window.open("https://d.gzsw168.com/source/apk/22501_5d7f8.apk", '_blank')
            
            break;
          case 1://mumu
            window.open("https://d.gzsw168.com/source/apk/22500_0ca98.apk", '_blank')
            
            break;
          case 2://安卓
            this.dowanload()
            break;
          case 3://苹果
            this.dowanload()
            break;
          case 4://taptap
            window.open("https://d.gzsw168.com/source/apk/22649_dcb4c.apk", '_blank')
            
            break;
          case 5://qq
            // https://qm.qq.com/cgi-bin/qm/qr?k=CA3-2tl6RdNEko-lompVK-vDIHqsBkM6&jump_from=webapi&authKey=cBrVMyfGxYrJq/IQvORN8V3e9p1qNc7bY4samQxquZvS/7vcKpG3NPJSiQJYUm+3
            window.open('https://qm.qq.com/cgi-bin/qm/qr?k=CA3-2tl6RdNEko-lompVK-vDIHqsBkM6&jump_from=webapi&authKey=cBrVMyfGxYrJq/IQvORN8V3e9p1qNc7bY4samQxquZvS/7vcKpG3NPJSiQJYUm+3', '_blank');
            break;
          case 6://微信
            this.showWeChatCodePage = true
            
            break;
        
          default:
            break;
        }
      },

    }
 }
</script>

<style>
  /* 禁止滚动的类 */
  .lock-scroll {
    overflow: hidden;
    height: 100%; /* 防止某些移动端浏览器无效 */
  }
</style>


// WEBPACK FOOTER //
// src/views/ReservationPage.vue